import React from "react";

function InfoIcon() {
  return (
    <svg
      width="23"
      height="23"
      viewBox="0 0 23 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.25 15.25V11.25M11.25 7.25H11.26M21.25 11.25C21.25 16.7728 16.7728 21.25 11.25 21.25C5.72715 21.25 1.25 16.7728 1.25 11.25C1.25 5.72715 5.72715 1.25 11.25 1.25C16.7728 1.25 21.25 5.72715 21.25 11.25Z"
        stroke="#667085"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default InfoIcon;
